"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PURPOSE = exports.PATIENT_RELATIONSHIP = exports.LOCATION_ID = exports.AVAIL_PURPOSE_VISIBILITY = exports.AVAIL_PURPOSE = exports.AVAIL_PATIENT_RELATIONSHIP = void 0;
const EHR = 'appointment_ehr_purposes';
const PATIENT_RELATIONSHIP = exports.PATIENT_RELATIONSHIP = 'patient_relationship';
const PURPOSE = exports.PURPOSE = 'purpose';
const AVAIL_PATIENT_RELATIONSHIP = exports.AVAIL_PATIENT_RELATIONSHIP = `${EHR}.${PATIENT_RELATIONSHIP}`;
const AVAIL_PURPOSE = exports.AVAIL_PURPOSE = `${EHR}.name`;
const AVAIL_PURPOSE_VISIBILITY = exports.AVAIL_PURPOSE_VISIBILITY = `${EHR}.ehr_data.visibilities`;
const LOCATION_ID = exports.LOCATION_ID = 'location_id';